import React, { useEffect, useState } from "react";
// import visitsAnalytics from "../../../../assets/analytics/visitsAnalytics.svg";
import { ReactComponent as VisitsAnalytics } from "../../../../assets/analytics/user-analytics/visitsAnalytics.svg";
import { ReactComponent as VisitsAnalyticsDark } from "../../../../assets/analytics/user-analytics/visitsAnalyticsDark.svg";

import useLocales from "../../../../hooks/useLocales";
import Duration from "./Duration";
import { useStateContext } from "../../../../contexts/ThemeContext";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";

import Visitor from "./Visitor";

import { ReactComponent as InstaIcon } from "../../../../assets/analytics/instagram.svg";
import { ReactComponent as TwitterIcon } from "../../../../assets/analytics/twitter.svg";
import { ReactComponent as YoutubeIcon } from "../../../../assets/analytics/youtube.svg";
import { ReactComponent as LinkedIn } from "../../../../assets/analytics/linkedin.svg";
import { ReactComponent as Pinterest } from "../../../../assets/analytics/pinterest.svg";
import { ReactComponent as FaceBookIcon } from "../../../../assets/analytics/facebook.svg";
import httpRequest from "../../../../axios/index";
import { useSelector } from "react-redux";

const iconSize = "w-6 h-6";

const ProAnalytics = () => {
  const { translate } = useLocales();
  const { darkMode } = useSelector((state) => state.theme);

  const socialAccounts = [
    {
      icon: <InstaIcon className={iconSize} />,
      name: translate("user_analytics.insta"),
      clicks: 0,
      platform: "Instagram",
    },
    {
      icon: <TwitterIcon className={iconSize} />,
      name: translate("user_analytics.twitter"),
      clicks: 0,
      platform: "Twitter",
    },
    {
      icon: <YoutubeIcon className={iconSize} />,
      name: translate("user_analytics.youtube"),
      clicks: 0,
      platform: "YouTube",
    },
    {
      icon: <LinkedIn className={iconSize} />,
      name: translate("user_analytics.linkedin"),
      clicks: 0,
      platform: "LinkedIn",
    },
    {
      icon: <Pinterest className={iconSize} />,
      name: translate("user_analytics.pinterest"),
      clicks: 0,
      platform: "Pinterest",
    },
    {
      icon: <FaceBookIcon className={iconSize} />,
      name: translate("user_analytics.facebook"),
      clicks: 0,
      platform: "Facebook",
    },
  ];

  const { setActiveUpgradeAnalyticsPageNav } = useStateContext();
  const [loading, setLoading] = useState(false);

  const [analyticsdata, setAnalyticsData] = useState(socialAccounts);

  const [analyticsCount, setAnalyticsCount] = useState(0);

  // const getAnalytics = async () => {
  //   try {
  //     setLoading(true);
  //     const { userid } = JSON.parse(localStorage.getItem("user")) || {};
  //     const resp = await httpRequest.get("/api/user/analytics/get/" + userid);
  //     if (resp?.data?.data && resp?.data?.data?.length) {
  //       const platForms = resp.data?.data;

  //       let count = 0;
  //       platForms.forEach((element) => {
  //         count = count + element?.data || 0;
  //       });
  //       setAnalyticsCount(count);

  //       const updatePlatform = analyticsdata.map((analytics) => {
  //         const singlePlatForm = platForms?.find(
  //           (platform) => platform?.platform === analytics?.platform
  //         );

  //         if (singlePlatForm && singlePlatForm?.data) {
  //           return {
  //             ...analytics,
  //             clicks: singlePlatForm?.data,
  //           };
  //         }
  //         return analytics;
  //       });
  //       setAnalyticsData(updatePlatform);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };

  // const getAnalytics = async (durationParam,startDate,endDate) => {
  //   try {
  //     setLoading(true);
  //     const { userid } = JSON.parse(localStorage.getItem("user")) || {};
  //     const resp = await httpRequest.get(`api/user/getanalytics/${userid}?duration=${durationParam}&startDate=${startDate}&endDate=${endDate}`);
  //     if (resp?.data?.data && resp?.data?.data?.length) {
  //       const platForms = resp.data?.data;

  //       let count = 0;
  //       platForms.forEach((element) => {
  //         count = count + element?.totalClicks || 0;
  //       });
  //       console.log(count);
  //       setAnalyticsCount(count);
  //       const updatePlatform = analyticsdata.map((analytics) => {
  //         const singlePlatForm = platForms?.find(
  //           (platform) => platform?.platform === analytics?.platform
  //         );

  //         if (singlePlatForm && singlePlatForm?.totalClicks) {
  //           return {
  //             ...analytics,
  //             clicks: singlePlatForm?.totalClicks,
  //           };
  //         }
  //         return analytics;
  //       });
  //       setAnalyticsData(updatePlatform);
  //       console.log(updatePlatform);

  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   getAnalytics();
  // }, []);

  useEffect(() => {
    setActiveUpgradeAnalyticsPageNav(true);
    return () => {
      setActiveUpgradeAnalyticsPageNav(false);
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Analytics | Bil.Bio</title>
        <meta property="og:title" content="Pro Analytics | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] overflow-y-auto">
        <div className="m-[100px] mt-10">
          <h6 className="text text-heading_color text-custom_h5 dark:text-color_v1_dark">
            {translate("user_analytics.analytics")}
          </h6>
          <p className="text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-color_v2_dark">
            {translate("user_analytics.some_states")}
          </p>
          <Duration
            socialAccounts={socialAccounts}
            setLoading={setLoading}
            setAnalyticsData={setAnalyticsData}
            analyticsdata={analyticsdata}
            setAnalyticsCount={setAnalyticsCount}
          />
        </div>

        <div className="grid lg:grid-flow-col gap-4 mx-[100px] my-10">
          <div className="col-span-1 lg:col-span-8">
            <div
              className={`flex items-center justify-between p-4 mb-6 rounded-lg md:rounded-[10px] ${
                darkMode ? "" : "shadow-box_shadow_1"
              } bg-light_bg_v5 dark:bg-dark-secondary cursor-pointer`}
            >
              <div>
                <div className="text-font_light_color dark:text-color_v2_dark text-small2_b">
                  {translate("user_analytics.no_visitor")}
                </div>
                <div className="text-custom_h5 dark:text-color_v1_dark">
                  {analyticsCount}
                </div>
              </div>
              {darkMode ? <VisitsAnalyticsDark /> : <VisitsAnalytics />}
            </div>

            <div
              className={`col-span-1 lg:row-span-8 lg:col-span-8 bg-light_bg_v5 dark:bg-dark-secondary  p-4 rounded-lg md:rounded-[10px] ${
                darkMode ? "" : "shadow-box_shadow_1"
              }`}
              style={{
                boxShadow: darkMode
                  ? ""
                  : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
              }}
            >
              <h6 className="my-4 text-custom_h6 dark:text-color_v1_dark">
                {translate("user_analytics.no_clicks")}
              </h6>
              {loading
                ? "Loading.."
                : analyticsdata?.map((account, index) => (
                    <div
                      key={index}
                      className={`flex items-center justify-between p-4 mb-2 rounded-lg md:rounded-[10px] ${
                        darkMode ? "" : "shadow-box_shadow_1"
                      } text-white w-full dark:bg-dark-primary`}
                      style={{ height: "60px" }}
                    >
                      <div className="flex items-center gap-2">
                        {account.icon}
                        <div className="text-[#3A3838] dark:text-color_v1_dark">
                          {account.name}
                        </div>
                      </div>
                      <div
                        className="text-[#3A3838] dark:text-color_v1_dark"
                        // style={{ color: "#3A3838" }}
                      >
                        {account.clicks}
                      </div>
                    </div>
                  ))}
            </div>
          </div>
          <div className="col-span-1 lg:row-span-3">
            <div
              className={`bg-light_bg_v5 dark:bg-dark-secondary pl-8 pb-8 pt-8	 rounded-lg md:rounded-t-[10px] ${
                darkMode ? "" : "shadow-box_shadow_1"
              } `}
            >
              <Visitor />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProAnalytics;
